import { BELIEVE } from "@/lib/content";
import { Quote } from "lucide-react";

export default function BelieveCards() {
  return (
    <section id="believe" data-testid="believe-section" className="relative scroll-mt-24 bg-[#0B0B0D] border-y border-[#27272A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="mb-12">
          <div className="text-[10px] uppercase tracking-[0.35em] text-[#FACC15]">
            Mindset on the road to Mesa
          </div>
          <h2 className="font-display uppercase tracking-tight text-5xl md:text-6xl mt-3 leading-[0.9]">
            Believe <span className="text-[#FACC15]">loud.</span><br />
            Work <span className="text-white">louder.</span>
          </h2>
          <p className="text-[#A1A1AA] mt-5 max-w-2xl font-light text-lg">
            The life skills we want him to carry off the court matter as much as the ones he
            builds on it. These are the truths we remind him of every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6">
          {BELIEVE.map((b, idx) => {
            const span =
              idx === 0
                ? "md:col-span-3"
                : idx === 1
                ? "md:col-span-3"
                : idx === 2
                ? "md:col-span-2"
                : idx === 3
                ? "md:col-span-2"
                : idx === 4
                ? "md:col-span-2"
                : "md:col-span-6";
            const isAccent = idx === 0 || idx === 5;
            return (
              <div
                key={idx}
                data-testid={`believe-card-${idx + 1}`}
                className={`${span} relative bg-[#18181B] border border-[#27272A] p-8 md:p-10 hover:border-[#FACC15]/60 transition-colors group`}
              >
                <Quote
                  className={`h-10 w-10 ${isAccent ? "text-[#FACC15]" : "text-[#52525B]"} mb-6 group-hover:rotate-[-6deg] transition-transform`}
                />
                <p
                  className={`font-display tracking-tight leading-[0.95] ${
                    isAccent ? "text-[#FACC15] text-4xl md:text-5xl" : "text-white text-3xl md:text-4xl"
                  }`}
                >
                  {b.quote}
                </p>
                <div className="mt-8 text-[10px] uppercase tracking-[0.3em] text-[#71717A]">
                  {b.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
